module.exports = __webpack_public_path__ + "static/HR Smartphone App AbaClik Aufgabenliste-f5353355c053eba4e84d8f8b8e6faf40.png";